import { PaginationQuery, PaginationQueryDefaultValues } from "../pagination/pagination-query"

export type TagQueryFilter = PaginationQuery & {
    TagKeyword:string,
    TagCategoryId:number,
    Status:string
}

export function TagQueryFilterDefaultValues():TagQueryFilter
{
    return {
        TagKeyword:'',
        TagCategoryId:0,
        Status:'',
        ...PaginationQueryDefaultValues()}
}